import React from 'react';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';
import { UnsavedChangesWarningProvider } from './UnsavedChangesWarning';

export const AppProviders = ({ children }: { children: JSX.Element }) => {
  return (
    <UnsavedChangesWarningProvider>
      <NetworkRoleProvider>
        <BrowserSizeProvider>{children}</BrowserSizeProvider>
      </NetworkRoleProvider>
    </UnsavedChangesWarningProvider>
  );
};
